import { memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'app/store';
import { ContextMenu as ContextMenuView, type Actions } from 'modules/editor/components/ContextMenu/ContextMenu';
import { devicesMeshApExistsSelector } from 'modules/devices/slice';
import { linksDeleteMeshPoint } from 'modules/links/externalActions';
import { linksAddMeshPoint } from 'modules/links/slice';
import { trackEvent } from 'utils/googleAnalytics';

const ContextMenuContainer = () => {
  const dispatch = useDispatch();

  const meshApExists = useSelector(devicesMeshApExistsSelector);

  const onAddMeshClick = useCallback(() => {
    dispatch(linksAddMeshPoint());
    trackEvent('canvasAddMesh');
  }, [dispatch]);

  const onDeleteMeshClick = useCallback(() => {
    dispatch(linksDeleteMeshPoint());
    trackEvent('canvasDeleteMesh');
  }, [dispatch]);

  const actions = useMemo<Actions>(() => {
    const actions: Actions = [];

    if (meshApExists) {
      actions.push({
        action: 'deleteMesh',
        onClick: onDeleteMeshClick,
        tooltip: 'Delete Mesh',
      });
    } else {
      actions.push({
        action: 'addMesh',
        onClick: onAddMeshClick,
        tooltip: 'Add Mesh',
      });
    }
    return actions;
  }, [meshApExists, onAddMeshClick, onDeleteMeshClick]);

  return <ContextMenuView actions={actions} />;
};

export const ContextMenu = memo(ContextMenuContainer);
